import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaOptionList from './VaOptionList.vue'

export const VaOptionList = withConfigTransport(_VaOptionList)
